// import Swiper JS
import AdvancedController from "./advanced-controller"
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import { Breakpoints } from '../utils/breakpoints';
import { gsap } from 'gsap'

export default class CompanyListController extends AdvancedController {

  static targets = [
  ]


  static values = {
  }

  connect() {
    console.log("connect");
  }

}